export const BACEN_PTAX_MOEDAS_URL =
  'https://olinda.bcb.gov.br/olinda/servico/PTAX/versao/v1/odata/Moedas';

export const MOEDAS_GOLDEN_BRL = 'BRL';
export const MOEDAS_GOLDEN_USD = 'USD';
export const MOEDAS_GOLDEN_EUR = 'EUR';

export const MOEDAS_MIN_CODES = 150;
export const MOEDAS_MAX_CODES = 200;
